module.exports = __webpack_public_path__ + "img/ZJ5291.4a966602.png";